module.exports = __webpack_public_path__ + "img/18.b695c4dd.png";